// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roster-kids__container{width:880px;height:380px;padding:0 16px 16px}.roster-kids .table__cell{min-width:20%}.roster-kids .table__cell .button{padding:2px 15px 0}`, "",{"version":3,"sources":["webpack://./src/modals/Roster/style.scss"],"names":[],"mappings":"AAEE,wBACE,WAAA,CACA,YAAA,CACA,mBAAA,CAGF,0BACE,aAAA,CACA,kCACE,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
